<template>
  <div class="wrapper-content w-100">
    <div class="row">
      <div class="col-12">
        <h1>Edición Home</h1>
           <LmBreadcrumb  v-if="showBreadcrumb"/>
      </div>
    </div>
    <LmForm ref="lmFormRef">

    <div class="row">
      <div class="col-12 mb-3">

      </div>
    </div>

    <div class="row position-relative">
      <LmComponentLoading v-if="formIsProcessing" ref="lmComponentLoading" />
      <div class="col-12 col-lg-2 ml-3">
        <div class="row ">
          <input type="text" class="form-control mb-3" v-model="inputSection" @keydown.enter.prevent="addSection()"
              name="inputSection" id="inputSection" placeholder="+ Agregar Sección">
          <!-- Dragable Secciones -->
          <draggable tag="ul" :list="sections" class="list-group w-100" handle=".handle" v-bind="dragOptions"
          @start="disambleBtnAgregarSecciones = true"
          >
            <transition-group type="transition" :name="'flip-list'">
              <li
              @click="clickBtnSeccion(element.id, element.title, element.type, element.bgcolor, element.titleLeftBoxColor, element.destacado, element.items, element.publish, element.background_image, element.background_image_mobile, element.sliderPrincipal, element.sliderDefault, element.vigencia_fin, element.vigencia_inicio, element.url, element.categoria, element.provinciasPrincipal, element.provinciasDefault, element.popupType)"
              tabindex="0"
              class="list-group-item section-button mb-3 d-flex align-items-center p-3 w-100"
               :class="{ active : active.id == element.id, 'bg-primary' : element.type === 'popup', 'bg-secondary' : element.type !== 'popup'  }" v-for="(element, index) in sections"
               :key="`draggable1-${index}`"
                v-bind="dragOptions">
                <!--
                  @click="activate(li.id)"
                  :class="element.component"
                -->
                <div class=" pr-3 float-left">
                  <font-awesome-icon class="handle" size="lg" :icon="element.type !== 'popup' ? 'bars' : 'window-restore'" />
                </div>
                {{ element.title }}
              </li>
            </transition-group>
          </draggable>

          <button class="btn btn-primary mt-lg-0 p-2 mb-3" :disabled="isGuardarSecciones" @click="submit('guardar')" disambled>
                Guardar secciones
          </button>

        </div>

      </div>

      <div class="col-lg-7 ml-lg-5 mt-lg-0 mt-sm-2" v-if="!active.title">
        <LmError title="No hay ninguna sección seleccionada" subtitle="Selecciona una sección del listado de la izquierda para editar el contenido" />
      </div>

      <div v-if="active.title" class="col-lg-7 ml-lg-5 mt-lg-0 mt-sm-2">
        <div class="ml-lg-2">

          <h3 class="mt-0">{{active.title}}</h3>

<b-alert show class="d-none">Recuerde guardar todo antes de cambiar de sección, para persistir los datos.</b-alert>

          <LmTextInput v-model="active.title" class="mt-1" />

          <LmSelect
        :options="types"
        label="Tipo de sección"
        v-model="active.type"
        v-if="active.type != 'popup'"
        />

        <div v-if="active.type == 'promotion'">
           <LmButton
              id="btn-add-marca"
              type="button"
              buttonClass="btn-success"
              :isProcessing="formIsProcessing"
              :value="$t('Agregar promoción')"
              lmButtonRootWrapperClass="d-inline-block mr-1 mb-4"
              lmButtonWrapperClass="col"
              @click.native="addItem"
            />

          <draggable tag="ul" :list="active.items" class="list-group" handle=".handle" v-bind="dragOptions"
          @start="disambleBtnGuardar = true"
          >
            <transition-group type="transition" :name="'flip-list'">

              <li class="list-group-item mb-3 pt-3  pb-1 LmMarca" v-for="(element, index) in active.items"
                :key="`draggable2-${index}`" v-bind="dragOptions">

                  <div class="row d-flex justify-content-start align-items-start">
                      <font-awesome-icon v-if="!element.removeDrag" class="handle ml-2 mr-3" style="width:3%" size="lg" icon="bars" />
                      <LmPromocionApp class="inputespecial" :options="element" @fileRemovedImage="fileRemovedImage" :imagetest="imagetest" :index="index" :apiUrlPath="form.apiUrlPath" />
                      <font-awesome-icon v-if="!element.removeDelete" class="close ml-3 mr-1 " style="width:3%;"  size="lg" icon="times" @click="removeAt(index)" />
                  </div>
              </li>

            </transition-group>
          </draggable>

        </div>
        <div v-if="active.type === 'popup'">
          <LmSelect
          :options="popupTypes"
          label="Tipo de popup"
          v-model="active.popupType"
          />
          <template v-if="active.popupType === 'imagen'">
            <label v-show="active.background_image">Imagen de fondo desktop</label>
            <LmImagenPages v-model="options" v-show="options.image" @fileRemoved="fileRemoved" class="my-2 mb-4" />
            <LmUploadFiles
            label="Imagen de fondo desktop"
            ref="lmUploadFiles"
            class="mb-3"
            :dropzoneOptions="dropzoneOptions"
            dictDefaultMessage='Arrastre la imagen acá para subirla'
            @vdropzone-removed-file="fileRemoved"
            @vdropzone-success="fileCreated"
            v-show="!options.image"
            />
            <label v-show="active.background_image_mobile">Imagen de fondo mobile</label>
            <LmImagenPages v-model="optionsMobile" v-show="optionsMobile.image" @fileRemoved="fileRemovedMobile" class="my-2 mb-4" />

            <LmUploadFiles
            label="Imagen de fondo mobile"
            ref="lmUploadFilesMobile"
            class="mb-3"
            :dropzoneOptions="dropzoneOptions"
            dictDefaultMessage='Arrastre la imagen acá para subirla'
            @vdropzone-removed-file="fileRemovedMobile"
            @vdropzone-success="fileCreatedMobile"
            v-show="!optionsMobile.image"
            />
            <LmTextInput v-model="active.url" label="URL" class="mt-1" @click.native="disambleBtnGuardar = true" />
          </template>
          <template v-else-if="active.popupType === 'youtube'">
            <LmTextInput id="input_youtube" v-model="active.youtube" label="URL Youtube (embed)" placeholder="https://www.youtube.com/embed/6CfXBb7d9CM?controls=0" class="mt-1" @click.native="disambleBtnGuardar = true" />
          </template>
          <LmDateTime
          v-model="active.vigencia_inicio"
          :config="lmDateTimeConfig"
          label="Fecha inicio de vigencia."
          :layout="['form-group']"
          @click.native="disambleBtnGuardar = true"
          />
          <LmDateTime
          v-model="active.vigencia_fin"
          :config="lmDateTimeConfig"
          label="Fecha fin de vigencia."
          :layout="['form-group']"
          @click.native="disambleBtnGuardar = true"
          />
        </div>

        <div v-if="active.type === 'carousel'">
<div class="row mt-4">
<div class="col-0 col-md-2 col-lg-4">
<b-form-checkbox
      id="checkDestacado"
      v-model="active.destacado"
      name="checkDestacado"
      value="destacado"
      unchecked-value="default"
      class="mb-3"
    >
      Destacar
    </b-form-checkbox>
</div>
      <div v-if="active.destacado != 'destacado'" class="col-0 col-md-3 d-flex">
        <label class="mr-2">Color título</label>
        <!-- <input type="color" id="head" name="head" v-model="active.titleLeftBoxColor" class="d-block mb-4"> -->

        <swatches
      v-model="active.titleLeftBoxColor"
      :swatches="swatches"
      :trigger-style="{ width: '26px', height: '26px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
      :swatch-style="{ width: '41px', height: '41px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
      show-fallback
      popover-to="left"
      class=""
    ></swatches>
    <br><br>
      </div>

      <div class="col-lg-12" v-if="active.destacado != 'destacado'">
          <LmTextInput label="Ver Todos" placeholder="Url" v-model="active.categoria" class="mt-1" />
      </div>

      <div v-if="active.destacado === 'destacado'" class="col-0 col-md-3 d-flex">
        <label class="mr-2">Color fondo</label>
        <!-- <input type="color" id="head" name="head" v-model="active.bgcolor" class="d-block mb-4"> -->

        <swatches
      v-model="active.bgcolor"
      :swatches="swatches"
      :trigger-style="{ width: '26px', height: '26px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
      :swatch-style="{ width: '41px', height: '41px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
      show-fallback
      popover-to="left"
    ></swatches>
    <br><br>
     </div>
     </div>
     <div v-if="active.destacado === 'destacado'">
      <label v-show="active.background_image">Imagen de fondo desktop</label>
     <LmImagenPages v-model="options" v-show="options.image" @fileRemoved="fileRemoved" class="my-2 mb-4" />

        <LmUploadFiles
        label="Imagen de fondo desktop"
        ref="lmUploadFiles"
        class="mb-3"
        :dropzoneOptions="dropzoneOptions"
        dictDefaultMessage='Arrastre la imagen acá para subirla'
        @vdropzone-removed-file="fileRemoved"
        @vdropzone-success="fileCreated"
        v-show="!options.image"
    />
    <label v-show="active.background_image_mobile">Imagen de fondo mobile</label>
     <LmImagenPages v-model="optionsMobile" v-show="optionsMobile.image" @fileRemoved="fileRemovedMobile" class="my-2 mb-4" />

        <LmUploadFiles
        label="Imagen de fondo mobile"
        ref="lmUploadFilesMobile"
        class="mb-3"
        :dropzoneOptions="dropzoneOptions"
        dictDefaultMessage='Arrastre la imagen acá para subirla'
        @vdropzone-removed-file="fileRemovedMobile"
        @vdropzone-success="fileCreatedMobile"
        v-show="!optionsMobile.image"
    />
    </div>
        <button class="btn btn-success mt-lg-0  p-2 mb-4 d-none" ></button>
        <hr class="mb-5 mt-4">
           <LmButton
              id="btn-add-marca"
              type="button"
              buttonClass="btn-success"
              :isProcessing="formIsProcessing"
              :value="$t('Agregar marca')"
              lmButtonRootWrapperClass="d-inline-block mr-1 mb-4"
              lmButtonWrapperClass="col"
              @click.native="addItem"
            />

          <!-- Dragable Marcas -->
          <draggable tag="ul" :list="active.items" class="list-group" handle=".handle" v-bind="dragOptions"
          @start="disambleBtnGuardar = true"
          >
            <transition-group type="transition" :name="'flip-list'" >

              <li class="list-group-item mb-3 LmMarca" v-for="(element, index) in active.items"
                :key="`draggable3-${index}`" v-bind="dragOptions">

                  <div class="row d-flex justify-content-start align-items-center">
                      <font-awesome-icon v-if="!element.removeDrag" class="handle ml-2 mr-3" style="width:2%" size="lg" icon="bars" />
                      <LmMarca :itemsMarcasTodas="itemsMarcasTodas" class="inputmarca" :index="index"  :options="element" />
                      <font-awesome-icon v-if="!element.removeDelete" class="close ml-3 mr-1 " style="width:2%;"  size="lg" icon="times" @click="removeAt(index)" />
                  </div>

              </li>

            </transition-group>
          </draggable>

          </div>

          <!-- Fin sec. Carrousel. v-if="active.type === 'specialSection1'" -->

          <div v-if="active.type === 'specialSection1'">

            <label v-if="active.background_image">Imagen de fondo</label>
            <LmImagenPages v-model="options" v-show="active.background_image" @fileRemoved="fileRemoved" class="my-2 mb-4" />

            <LmUploadFiles
            label="Imagen de fondo"
            ref="lmUploadFiles"
            class="mb-3"
            :dropzoneOptions="dropzoneOptions"
            dictDefaultMessage='Arrastre la imagen acá para subirla'
            @vdropzone-removed-file="fileRemoved"
            @vdropzone-success="fileCreated"
            v-show="!options.image"
        />

        <LmImagenPages v-model="optionsMobile" v-show="active.background_image_mobile" @fileRemoved="fileRemovedMobile" class="my-2 mb-4" />

        <LmUploadFiles
        label="Imagen de fondo mobile"
        ref="lmUploadFilesMobile"
        class="mb-3"
        :dropzoneOptions="dropzoneOptions"
        dictDefaultMessage='Arrastre la imagen acá para subirla'
        @vdropzone-removed-file="fileRemovedMobile"
        @vdropzone-success="fileCreatedMobile"
        v-show="!optionsMobile.image"
    />

               <LmButton
              id="btn-sec-especial"
              type="button"
              buttonClass="btn-success"
              :isProcessing="formIsProcessing"
              :value="$t('Agregar sección especial')"
              lmButtonRootWrapperClass="d-inline-block mr-1 mb-4"
              lmButtonWrapperClass="col"
              @click.native="addItem"
              v-if="active.items.length<3"
            />

            <!-- Dragable Sección especial -->
          <draggable tag="ul" :list="active.items" class="list-group" handle=".handle" v-bind="dragOptions"
          @start="disambleBtnGuardar = true"
          >
            <transition-group type="transition" :name="'flip-list'">

              <li class="list-group-item mb-3 pt-3  pb-1 LmMarca" v-for="(element, index) in active.items"
                :key="`draggable4-${index}`" v-bind="dragOptions">

                  <div class="row d-flex justify-content-start align-items-start">
                      <font-awesome-icon v-if="!element.removeDrag" class="handle ml-2 mr-3" style="width:3%" size="lg" icon="bars" />
                      <LmSeccionEspecial class="inputespecial" :options="element" @fileRemovedImage="fileRemovedImage" :imagetest="imagetest" :index="index" :apiUrlPath="form.apiUrlPath" />
                      <font-awesome-icon v-if="!element.removeDelete" class="close ml-3 mr-1 " style="width:3%;"  size="lg" icon="times" @click="removeAt(index)" />
                  </div>
              </li>

            </transition-group>
          </draggable>
          </div>

          <!-- Fin sec. Sección especial. v-if="active.type === 'specialSection1'" -->

            <!-- Fin sec. Carrousel. v-if="active.type === 'specialSection1'" -->

          <div v-if="active.type === 'nichos'">

                  <LmButton
              id="btn-nichos"
              type="button"
              buttonClass="btn-success"
              :isProcessing="formIsProcessing"
              :value="$t('Agregar Nicho')"
              lmButtonRootWrapperClass="d-inline-block mr-1 mb-4"
              lmButtonWrapperClass="col"
              @click.native="addItem"
              v-if="active.items.length<2"
            />

            <!-- Dragable Sección especial -->
          <draggable tag="ul" :list="active.items" class="list-group" handle=".handle" v-bind="dragOptions" @update="dragableUpdate"
          @start="disambleBtnGuardar = true"
          >
            <transition-group type="transition" :name="'flip-list'">

              <li class="list-group-item mb-3 pt-3  pb-1 LmMarca" v-for="(element, index) in active.items"
                :key="`draggable5-${index}`" v-bind="dragOptions">

                  <div class="row d-flex justify-content-start align-items-start">
                      <font-awesome-icon v-if="!element.removeDrag" class="handle ml-2 mr-3" style="width:3%" size="lg" icon="bars" />
                      <LmNicho class="inputnicho" :options="element" :imagetest="imagetest" @fileRemovedImage="fileRemovedImage" :index="index" :apiUrlPath="form.apiUrlPath" />
                      <font-awesome-icon v-if="!element.removeDelete" class="close ml-3 mr-1 " style="width:4%;"  size="lg" icon="times" @click="removeAt(index)" />
                  </div>

              </li>

            </transition-group>
          </draggable>
          </div>
          <div v-if="active.type === 'provinciasPrincipal'" class="preview-provincias">
              <LmSuperPowerSelectV2
              ref="provinciasPrincipal"
              label="Provincias principal"
              v-model="active.provinciasPrincipal"
              urlPathFromGetOptions="provincias/todos/"
              :key="'principal'+key"
            />
            <LmSuperPowerSelectV2
              label="Provincias default"
              v-model="active.provinciasDefault"
              urlPathFromGetOptions="provincias/defaults/"
              class="mb-1"
              :key="'default'+key"
              @change="disambleBtnGuardar = true"
            />
            <small>Cuando no hay provincia activa.</small>
          <h4>Preview</h4>

          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio v-model="selectedPreview" :aria-describedby="ariaDescribedby" name="some-radios" value="principal" class="d-inline" :selected="selectedPreview === 'principal' ? true : false">Principal</b-form-radio>
            <b-form-radio v-model="selectedPreview" :aria-describedby="ariaDescribedby" name="some-radios" value="default" class="d-inline ml-3" :selected="selectedPreview === 'default' ? true : false">Default</b-form-radio>
          </b-form-group>

          <div v-if="active.provinciasPrincipal.imagenes && selectedPreview === 'principal'" >
          <b-tabs content-class="mt-3" lazy>
          <b-tab title="Desktop">
            <b-carousel
                      id="carousel-1"
                      :interval="4000"
                      controls
                      indicators
                      background="#ababab"
                      img-width="1024"
                      img-height="480"
                      class="slide-provincias"
                    >
                        <!-- Text slides with image -->
                        <b-carousel-slide
                          v-for="(item, index) in active.provinciasPrincipal.imagenes" :key="`provincias1-${index}`"
                          :img-src="baseUrl + item.imagen_desktop"
                        >
                        <div class="wrap-text">
                            <h2 class="title">{{ item.title }}</h2>
                            <div class="subtitle">{{ item.subtitle }}</div>
                            <div class="text">{{ item.text }}</div>
                          </div>
                      </b-carousel-slide>
            </b-carousel>
          </b-tab>
          <b-tab title="Mobile">
            <div class="w-50 m-auto" style="max-width:200px;max-height:300px">
            <b-carousel
                      id="carousel-provincias-2"
                      :interval="4000"
                      controls
                      indicators
                      background="#ababab"
                      img-width="200"
                      img-height="300"
                    >
                        <b-carousel-slide
                          v-for="(item, index) in active.provinciasPrincipal.imagenes" :key="`provincias2-${index}`"
                          :img-src="baseUrl + item.imagen_mobile"
                        >
                        <div class="wrap-text">
                            <h2 class="title">{{ item.title }}</h2>
                            <div class="subtitle">{{ item.subtitle }}</div>
                            <div class="text">{{ item.text }}</div>
                          </div>
                      </b-carousel-slide>
                      </b-carousel>
                      </div>
          </b-tab>
        </b-tabs>
          </div>

          <div v-if="active.provinciasDefault.imagenes && selectedPreview === 'default'" >
          <b-tabs content-class="mt-3" lazy>
          <b-tab title="Desktop">
            <b-carousel
                      id="carousel-1"
                      :interval="4000"
                      controls
                      indicators
                      background="#ababab"
                      img-width="1024"
                      img-height="480"
                      class="slide-provincias"
                    >
                        <!-- Text slides with image -->
                        <b-carousel-slide
                          v-for="(item, index) in active.provinciasDefault.imagenes" :key="`provincias3-${index}`"
                          :img-src="baseUrl + item.imagen_desktop"
                        >
                        <div class="wrap-text">
                            <h2 class="title">{{ item.title }}</h2>
                            <div class="subtitle">{{ item.subtitle }}</div>
                            <div class="text">{{ item.text }}</div>
                          </div>
                      </b-carousel-slide>
            </b-carousel>
          </b-tab>
          <b-tab title="Mobile">
            <div class="w-50 m-auto" style="max-width:200px;max-height:300px">
            <b-carousel
                      id="carousel-provincias-2"
                      :interval="4000"
                      controls
                      indicators
                      background="#ababab"
                      img-width="200"
                      img-height="300"
                    >
                        <b-carousel-slide
                          v-for="(item, index) in active.provinciasDefault.imagenes" :key="`provincias4-${index}`"
                          :img-src="baseUrl + item.imagen_mobile"
                        >
                        <div class="wrap-text">
                            <h2 class="title">{{ item.title }}</h2>
                            <div class="subtitle">{{ item.subtitle }}</div>
                            <div class="text">{{ item.text }}</div>
                          </div>
                      </b-carousel-slide>
                      </b-carousel>
                      </div>
          </b-tab>
        </b-tabs>
      </div>

        </div>

          <div v-if="active.type === 'sliderPrincipal'">
            <LmSuperPowerSelectV2
            ref="sliderPrincipal"
            label="Slider principal"
            v-model="active.sliderPrincipal"
            urlPathFromGetOptions="sliders/todos/"
            :key="'principal'+key"
          />
          <LmSuperPowerSelectV2
            label="Slider default"
            v-model="active.sliderDefault"
            urlPathFromGetOptions="sliders/defaults/"
            class="mb-1"
            :key="'default'+key"
            @change="disambleBtnGuardar = true"
          />

          <small>Cuando no hay slider activo.</small>
          <h4>Preview</h4>

          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio v-model="selectedPreview" :aria-describedby="ariaDescribedby" name="some-radios" value="principal" class="d-inline" :selected="selectedPreview === 'principal' ? true : false">Principal</b-form-radio>
            <b-form-radio v-model="selectedPreview" :aria-describedby="ariaDescribedby" name="some-radios" value="default" class="d-inline ml-3" :selected="selectedPreview === 'default' ? true : false">Default</b-form-radio>
          </b-form-group>

          <div v-if="active.sliderPrincipal.imagenes && selectedPreview === 'principal'" >
          <b-tabs content-class="mt-3" lazy>
          <b-tab title="Desktop">
            <b-carousel
                      id="carousel-1"
                      :interval="4000"
                      controls
                      indicators
                      background="#ababab"
                      img-width="1024"
                      img-height="480"
                      style="text-shadow: 1px 1px 2px #333;"
                    >
                        <!-- Text slides with image -->
                        <div v-for="(item, index) in active.sliderPrincipal.imagenes" :key="`${item.fecha_inicio}-${item.fecha_fin}-${index}`">
                        <b-carousel-slide
                          :img-src="baseUrl + item.imagen_desktop"
                          v-if="isVigente(item.fecha_inicio, item.fecha_fin)"
                        ></b-carousel-slide>
                        </div>
            </b-carousel>
          </b-tab>
          <b-tab title="Mobile">
            <div class="w-50 m-auto">
            <b-carousel
                      id="carousel-2"
                      :interval="4000"
                      controls
                      indicators
                      background="#ababab"
                      img-width="1024"
                      img-height="480"
                      style="text-shadow: 1px 1px 2px #333;"
                    >
                      <div v-for="(item, index) in active.sliderPrincipal.imagenes" :key="`slider2-${index}`">
                        <b-carousel-slide
                          v-if="isVigente(item.fecha_inicio, item.fecha_fin)"
                          :img-src="baseUrl + item.imagen_mobile"
                        ></b-carousel-slide>
                        </div>
                      </b-carousel>
                      </div>
          </b-tab>
        </b-tabs>
      </div>

      <div v-if="active.sliderDefault.imagenes && selectedPreview === 'default'" >
          <b-tabs content-class="mt-3" lazy>
          <b-tab title="Desktop">
            <b-carousel
                      id="carousel-1"
                      :interval="4000"
                      controls
                      indicators
                      background="#ababab"
                      img-width="1024"
                      img-height="480"
                      style="text-shadow: 1px 1px 2px #333;"
                    >
                        <!-- Text slides with image -->
                        <b-carousel-slide
                          v-for="(item, index) in active.sliderDefault.imagenes" :key="`slider3-${index}`"
                          :img-src="baseUrl + item.imagen_desktop"
                        ></b-carousel-slide>
            </b-carousel>
          </b-tab>
          <b-tab title="Mobile">
            <div class="w-50 m-auto">
            <b-carousel
                      id="carousel-2"
                      :interval="4000"
                      controls
                      indicators
                      background="#ababab"
                      img-width="1024"
                      img-height="480"
                      style="text-shadow: 1px 1px 2px #333;"
                    >
                        <b-carousel-slide
                          v-for="(item, index) in active.sliderDefault.imagenes" :key="`slider4-${index}`"
                          :img-src="baseUrl + item.imagen_mobile"
                        ></b-carousel-slide>
                      </b-carousel>
                      </div>
          </b-tab>
        </b-tabs>
      </div>

          </div>

               <b-form-checkbox
      id="publish"
      v-model="active.publish"
      name="publish"
      :value="true"
      :unchecked-value="false"
      class="my-3"
      switch
      size="lg"
    >
      Publicar
    </b-form-checkbox>

   <!-- <b-form-checkbox
      id="verArray"
      v-model="verArray"
      name="verArray"
      value="true"
      unchecked-value="false"
      class="mb-2"
    >
      Ver array
    </b-form-checkbox>

   <pre v-if="verArray === 'true'" class="mb-3">
      {{ active }}
    </pre> -->

          <div class="d-flex justify-content-start border-top border-light py-3">

                   <LmButton
              id="btn-eliminar"
              type="button"
              buttonClass="btn-danger"
              :isProcessing="formIsProcessing"
              :value="$t('Eliminar Sección')"
              lmButtonRootWrapperClass="d-inline-block mr-1"
              lmButtonWrapperClass="col"
              v-b-modal.modal-center
              v-if="active.type !== 'popup'"
            />

            <LmButton
              id="btn-volver"
              type="button"
              buttonClass="btn-secondary"
              :isProcessing="formIsProcessing"
              :value="$t('Volver')"
              lmButtonRootWrapperClass="d-inline-block mr-1"
              lmButtonWrapperClass="col"
              @click.native="volver"
            />

            <!-- Botón Guardar Sección -->
                    <LmButton
              id="btn-guardar"
              type="submit"
              buttonClass="btn-primary"
              :value="$t('Guardar')"
              lmButtonRootWrapperClass="d-inline-block mr-1"
              lmButtonWrapperClass="col"
              @click.native="guardar"
              :disabled="isGuardarSeccion"
            />

          </div>
        </div>
      </div>
    </div>

  <b-modal id="modal-center" centered title="Eliminar Sección">
    <p class="my-4">¿Está seguro que desea eliminar la sección <b>{{active.title}}</b>?</p>

       <template v-slot:modal-footer="{ cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
       <b-button size="sm" variant="secondary" @click="cancel()">
        Cancel
      </b-button>

      <b-button size="sm" variant="danger"  @click="removeSection(active.id), cancel()">
        Eliminar {{active.title}}
      </b-button>

    </template>

  </b-modal>

        </LmForm>
  </div>
</template>

<script>
import store from '@/store'
import axios from 'axios'
import commonsApi from '@/api/commons'
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
import _ from 'lodash'
import moment from 'moment'

import draggable from 'vuedraggable'
import LmForm from '@/components/form/LmForm.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
import LmBtnListado from './elements/LmBtnListado'
import LmMarca from './elements/LmMarca'
import LmSeccionEspecial from './elements/LmSeccionEspecial'
import LmPromocionApp from './elements/LmPromocionApp'
import LmNicho from './elements/LmNicho'
import LmDashboard from './elements/LmDashboard'
import LmSelect from '@/components/form/elements/LmSelect'
import LmUploadFiles from '@/components/LmUploadFiles'
import LmImagenPages from '@/views/365/pages/elements/LmImagenPages'
import LmError from '@/components/LmError'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2.vue'
import LmDateTime from '@/components/form/elements/LmDateTime'

export default {
  name: 'handle',
  display: 'Handle',
  instruction: 'Drag using the handle icon',
  order: 5,
  components: {
    draggable,
    LmButton,
    LmTextInput,
    LmForm,
    LmBtnListado,
    LmMarca,
    LmSeccionEspecial,
    LmNicho,
    LmDashboard,
    LmSelect,
    LmUploadFiles,
    LmImagenPages,
    Swatches,
    LmError,
    LmPromocionApp,
    LmSuperPowerSelectV2,
    LmDateTime
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      imagetest: '',
      disambleBtnAgregarSecciones: false,
      disambleBtnGuardar: false,
      sliderSelected: {},
      selectedPreview: 'principal',
      slide: 0,
      indexPreview: 0,
      key: 0,
      sliding: null,
      baseUrl: process.env.VUE_APP_API_URL_STATIC_ASSETS,
      swatches: ['#f03d37', '#000000', '#ffffff'],
      types: { // Valores del select "tipo de sección".
        content: [
          { value: 'carousel', text: 'Carrusel' },
          { value: 'promotion', text: 'Promoción' },
          { value: 'specialSection1', text: 'Sección especial' },
          { value: 'nichos', text: 'Nichos' },
          { value: 'sliderPrincipal', text: 'Slider principal' },
          { value: 'provinciasPrincipal', text: 'Provincias' }
        ] },
      popupTypes: { // Valores del select "tipo de sección".
        content: [
          { value: 'imagen', text: 'Imagen' },
          { value: 'youtube', text: 'Video Youtube' }
        ] },
      lmDateTimeConfig: {
        dateFormat: 'Y-m-d H:i',
        allowInput: true,
        enableTime: true,
        minDate: 0
      },
      form: {
        apiUrlPath: ''
      },
      active: { // Donde se cargan todos los nodos del item activo.
        id: null,
        title: '',
        bgcolor: '',
        titleLeftBoxColor: '',
        type: '', // Donde se cambia el valor por default del select "tipo de sección". Todos los valores están en types.content
        popupType: 'imagen',
        destacado: 'default', // Valor Checkbox destacado,
        background_image: '',
        background_image_mobile: '',
        image: '',
        youtube: '',
        publish: false,
        sliderPrincipal: {},
        sliderDefault: {},
        provinciasPrincipal: {},
        provinciasDefault: {},
        categoria: '',
        items: [] // Items con las marcas
      },
      itemsMarcasTodas: [], // Lista que se extrae desde el endpoint de todas las marcas.
      sections: [], // Donde se cargan las secciones de la DB.
      inputSection: '', // Donde se carga una nueva sección.
      verArray: 'false',
      loading: false,
      loadingRemove: false,
      formIsProcessing: false,
      files: [],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${store.state.session.accessToken}`
        },
        withCredentials: true,
        thumbnailWidth: 150,
        maxFiles: 1,
        addRemoveLinks: true,
        acceptedFiles: 'image/*'
      },
      options: {
        type: Object,
        idRandom: '',
        id: '',
        title: '',
        image: '',
        imageOriginalName: '',
        imageSize: '',
        default: () => ({
          disabledOption: 'Seleccione una acción',
          content: []
        })
      },
      optionsMobile: {
        type: Object,
        idRandom: '',
        id: '',
        title: '',
        image: '',
        imageOriginalName: '',
        imageSize: '',
        default: () => ({
          disabledOption: 'Seleccione una acción',
          content: []
        })
      }
    }
  },
  computed: {
    dragOptions () {
      return {
        animation: 200,
        group: 'transition',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    isGuardarSecciones () {
      return !this.disambleBtnAgregarSecciones
    },
    isGuardarSeccion () {
      let i = this.sections.findIndex(item => item.id === this.active.id)

      if (
        this.active.title === this.sections[i].title &&
        this.active.bgcolor === this.sections[i].bgcolor &&
        this.active.destacado === this.sections[i].destacado &&
        this.active.background_image === this.sections[i].background_image &&
        this.active.background_image_mobile === this.sections[i].background_image_mobile &&
        this.active.titleLeftBoxColor === this.sections[i].titleLeftBoxColor &&
        this.active.type === this.sections[i].type &&
        this.active.image === this.sections[i].image &&
        this.active.publish === this.sections[i].publish &&
        this.active.sliderPrincipal === this.sections[i].sliderPrincipal &&
        this.active.sliderDefault === this.sections[i].sliderDefault &&
        this.active.provinciasPrincipal === this.sections[i].provinciasPrincipal &&
        this.active.provinciasDefault === this.sections[i].provinciasDefault &&
        this.active.categoria === this.sections[i].categoria
      ) {
        return !this.disambleBtnGuardar
      }
    }
  },
  methods: {
    isVigente (fechaInicio, fechaFin) {
      const result = moment().isBetween(fechaInicio, fechaFin)
      return result
    },
    deleteSlider (index) {
      this.indexPreview = 0
      this.active.items.splice(index, 1)
    },
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    },
    dragableUpdate (el) {
      this.imagetest = process.env.VUE_APP_API_URL_STATIC_ASSETS + this.active.items[1].image
      // console.log(process.env.VUE_APP_API_URL_STATIC_ASSETS + this.active.items[1].image)
      // console.log('element:' + el)
    },
    fileRemovedImage (index) {
      this.active.items[index].image = ''
    },
    guardar () {
      const even = (a) => a.id > 0

      if (this.active.destacado === 'default') {
        this.active.bgcolor = ''
      } else if (this.active.destacado === 'destacado') {
        this.active.titleLeftBoxColor = ''
      }
      if (this.active.type === 'nichos' && this.active.items.length < 2) {
        this.makeToast('nicho')
      } else if (this.active.type === 'sliderPrincipal' && (_.isEmpty(this.active.sliderPrincipal) || _.isEmpty(this.active.sliderDefault))) {
        this.makeToast('slider')
      } else if (this.active.type === 'provinciasPrincipal' && (_.isEmpty(this.active.provinciasPrincipal) || _.isEmpty(this.active.provinciasDefault))) {
        this.makeToast('provincias')
      } else if (this.active.type === 'carousel' && !this.active.items.some(even)) {
        this.makeToast('carousel')
      } else {
        let i = this.sections.findIndex(item => item.id === this.active.id)
        this.sections.splice(i, 1, { ...this.active }) // remove it from array
        this.loading = true
        this.submit('guardar')
      }
    },
    volver () {
      this.active = {
        id: null,
        title: '',
        bgcolor: '',
        titleLeftBoxColor: '',
        type: '',
        destacado: 'default',
        background_image: '',
        background_image_mobile: '',
        image: '',
        publish: false,
        sliderPrincipal: {},
        sliderDefault: {},
        provinciasPrincipal: {},
        provinciasDefault: {},
        items: []
      }
    },
    async submit (toast) {
      this.disambleBtnGuardar = false
      try {
        this.formIsProcessing = true
        const dataToSendToTheServer = {
          page: JSON.stringify(this.sections)
        }

        await axios.post(
          `${process.env.VUE_APP_API_URL}pages/edit-home/`,
          dataToSendToTheServer,
          {
            headers: {
              Authorization: `Bearer ${store.state.session.accessToken}`
            }
          }
        )
        if (toast === 'guardar') {
          this.makeToast('guardar')
        }
        if (toast === 'eliminar') {
          this.makeToast('eliminar')
        }
        this.setForm()
        this.disambleBtnAgregarSecciones = false
        // this.$router.go()
      } catch (e) {
        console.log(e)
      } finally {
        document.getElementById('inputSection').focus()
        this.formIsProcessing = false
      }
    },

    async setForm () {
      await this.$refs.lmFormRef.activeEditMode({
        path: 'pages/read-home/'
      })
      if (this.form.page) {
        this.sections = this.form.page
        if (!this.sections.some(el => el.type === 'popup')) {
          this.sections.unshift({
            id: 'pop12345',
            title: 'Popup',
            type: 'popup',
            background_image: '',
            background_image_mobile: '',
            vigencia_inicio: '',
            vigencia_fin: '',
            url: '',
            publish: true
          })
        }
      }
    },

    async getMarcasItems () {
      const response = await commonsApi.getItemDetail({
        path: '/marcas',
        id: 'todos/',
        paramsMode: true
      })
      this.itemsMarcasTodas = response.items
      // console.log('response: ', response)
    },

    // Toma los parametros del botón de cada sección y los coloca en el array items
    // el método está dentro del drag, por lo tanto es escuchado continuamente.
    clickBtnSeccion (id, title, type, bgcolor, titleLeftBoxColor, destacado, items, publish, backgroundImage, backgroundImageMobile, sliderPrincipal, sliderDefault, vigenciaFin, vigenciaInicio, url, categoria, provinciasPrincipal, provinciasDefault, popupType) {
      this.active.id = id
      this.active.title = title
      this.active.type = type
      this.active.bgcolor = bgcolor
      this.active.titleLeftBoxColor = titleLeftBoxColor
      this.active.destacado = destacado
      this.active.publish = publish
      this.active.background_image = backgroundImage
      this.active.background_image_mobile = backgroundImageMobile
      this.active.background_image ? this.options.image = this.active?.background_image : this.options.image = ''
      this.active.background_image_mobile ? this.optionsMobile.image = this.active?.background_image_mobile : this.optionsMobile.image = ''
      this.active.sliderPrincipal = sliderPrincipal
      this.active.sliderDefault = sliderDefault
      this.active.categoria = categoria
      this.active.vigencia_fin = vigenciaFin
      this.active.vigencia_inicio = vigenciaInicio
      this.active.url = url
      this.active.provinciasPrincipal = provinciasPrincipal
      this.active.provinciasDefault = provinciasDefault
      this.active.sliderPrincipal = sliderPrincipal
      this.active.sliderDefault = sliderDefault
      this.active.vigencia_fin = vigenciaFin
      this.active.url = url
      this.active.categoria = categoria
      this.active.popupType = popupType
      if (this.active.background_image) this.options.image = this.active.background_image
      if (items) {
        this.active.items = items
      } else {
        this.active.items = []
      }
      this.active.type = type
      this.selectedPreview = 'principal'
      this.key++
    },
    removeSection (id) {
      let i = this.sections.map(item => item.id).indexOf(id) // find index of your object
      this.sections.splice(i, 1) // remove it from array
      this.loadingRemove = true
      this.submit('eliminar')
      this.volver()
    },

    removeAt (index) {
      this.active.items.splice(index, 1)
      this.disambleBtnGuardar = true
    },

    addItem () {
      this.disambleBtnGuardar = true

      if (this.active.type === 'promotion') {
        this.active.items.push({
          image: '',
          urlAppStore: '',
          urlPlayStore: '',
          title: '',
          titleColor: '#f03d37',
          background: '#fff3ce'
        })
      }

      if (this.active.type === 'carousel') {
        this.active.items.push({
          companyName: '',
          id: ''
        })
      }

      if (this.active.type === 'specialSection1' && this.active.items.length < 3) {
        this.active.items.push({
          title: ''
        })
      }

      if (this.active.type === 'nichos' && this.active.items.length < 2) {
        if (this.active.items.length === 0) {
          this.active.items.push({
            title: '',
            idRandom: '',
            image: ''
          })
          this.active.items.push({
            title: '',
            idRandom: '',
            image: ''
          })
        }

        if (this.active.items.length === 1) {
          this.active.items.push({
            title: '',
            idRandom: '',
            image: ''
          })
        }
      }

      if (this.active.type === 'sliderPrincipal') {
        this.active.items.push(this.sliderSelected)
      }
      if (this.active.type === 'provinciasPrincipal') {
        this.active.items.push(this.provinciasSelected)
      }
    },
    addSection () {
      if (this.inputSection) {
        this.sections.push({
          id: Math.random().toString(36).substr(2, 9),
          title: this.inputSection,
          component: 'LmBtnListado',
          type: 'carousel',
          bgcolor: '#ffffff',
          titleLeftBoxColor: '#F03D37',
          background_image: '',
          background_image_mobile: '',
          destacado: 'default', // Valor Checkbox destacado,
          image: '',
          publish: false,
          items: [], // Items con las marcas
          sliderPrincipal: {},
          sliderDefault: {},
          vigencia_fin: '',
          vigencia_inicio: '',
          url: '',
          provinciasPrincipal: {},
          provinciasDefault: {},
          options: {
          // disabledOption: 'Seleccione un evento',
          // content: ['Elegir Marca', 'Elegir Ropa']
          }
        })
      }
      this.inputSection = ''
      this.disambleBtnAgregarSecciones = true
    },
    makeToast (variant = null) {
      if (variant === 'guardar') {
        this.$bvToast.toast('El contenido se guardó exitosamente.', {
          title: `Mensaje`,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-center'
        })
      }
      if (variant === 'eliminar') {
        this.$bvToast.toast('La sección se eliminó exitosamente.', {
          title: `Mensaje`,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-center'
        })
      }
      if (variant === 'nicho') {
        this.$bvToast.toast('Debe cargar más de un nicho', {
          title: `Mensaje`,
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-bottom-center'
        })
      }
      if (variant === 'slider') {
        this.$bvToast.toast('Debe cargar los sliders.', {
          title: `Mensaje`,
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-bottom-center'
        })
      }
      if (variant === 'provincias') {
        this.$bvToast.toast('Debe cargar las provincias.', {
          title: `Mensaje`,
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-bottom-center'
        })
      }
      if (variant === 'carousel') {
        this.$bvToast.toast('Debe cargar alguna marca', {
          title: `Mensaje`,
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-bottom-center'
        })
      }
      if (variant === 'bgImages') {
        this.$bvToast.toast('Debe cargar las imágenes de fondo', {
          title: `Mensaje`,
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-bottom-center'
        })
      }
    },
    fileCreated (file, response) {
      if (response) {
        setTimeout(() => {
          this.options.idRandom = Math.random()
        }, 1000
        )
        this.active.background_image = response.path
        this.options.image = response.path
        this.files.push(response)
      }
      this.$refs.lmUploadFiles.disable()
    },
    fileCreatedMobile (file, response) {
      if (response) {
        setTimeout(() => {
          this.optionsMobile.idRandom = Math.random()
        }, 1000
        )
        this.active.background_image_mobile = response.path
        this.optionsMobile.image = response.path
        this.files.push(response)
      }
      this.$refs.lmUploadFilesMobile.disable()
    },
    fileRemoved (file, error, xhr) {
      this.active.background_image = ''
      this.options.image = ''
      this.files = []
      if (file) {
        this.files = this.files.filter(f => f.originalname !== file.name)
      }
      this.$refs.lmUploadFiles.lmRemoveAllFiles()
      this.$refs.lmUploadFiles.enable()
    },
    fileRemovedMobile (file, error, xhr) {
      this.active.background_image_mobile = ''
      this.optionsMobile.image = ''
      this.files = []
      if (file) {
        this.files = this.files.filter(f => f.originalname !== file.name)
      }
      this.$refs.lmUploadFilesMobile.lmRemoveAllFiles()
      this.$refs.lmUploadFilesMobile.enable()
    },
    bytesToSize (bytes) {
      const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
    }
  },
  created () {
    this.getMarcasItems()
    // this.getSectionsItems()
  },
  mounted () {
    this.setForm()
  }

}
</script>
<style lang="sass" scoped>
.inputmarca
  width: 90%
  @media(max-width: 1650px)
    width: 88%
  @media(max-width: 1300px)
    width: 85%
  @media(max-width: 500px)
    width: 80%

.inputnicho, .inputespecial
  width: 87%
  @media(max-width: 1650px)
    width: 85%
  @media(max-width: 1300px)
    width: 83%
  @media(max-width: 500px)
    width: 80%

#btn-eliminar:focus, #btn-eliminar:actived
  outline: none
.list-group-item
  color: white
  &.LmMarca
    color: #000
    border-color: #bbb
    background: #bbb
  .text
    margin: 20px 10px 20px 20px
    font-weight: bold
    font-size: 16px
  .close
    color: #000
    opacity: 1
    cursor: pointer
    transform: scale(0.85)

  .handle
    cursor: grab
.section-button
  cursor: pointer

.section-button:hover

.section-button:focus
  outline: none

ul > li:hover
cursor:pointer

.trash, .eye
  cursor: pointer
.preview-provincias
  max-width: 700px
.slide-provincias
  border-radius: 40px
  .wrap-text
    position: absolute
    bottom: 0
    margin: 50px 0px
    background: rgba(255,255,255,0.8)
    border-radius: 10px
    padding: 20px
    max-width: 60%
    text-align: left
    .title
      color: #f03d37
      font-weight: bold
    .subtitle
      color: #f03d37
      font-size: 1.2em
    .text
      color: #333
      font-size: 1em
      margin-top: 5px
      padding-bottom: 5px
    .vermas
      background: #f03d37
      border-radius: 50px
      color: #ffffff
      font-weight: 300
      padding: 4px 20px
      font-size: 0.7em
      position: absolute
      bottom: 0
      right: 0
      margin-bottom: -11px
      margin-right: 30px
#carousel-provincias-2
  .wrap-text
    position: absolute
    bottom: 0
    margin: 5px 5px 24px 5px
    background: rgba(255,255,255,0.8)
    border-radius: 10px
    padding: 10px
    width: 100%
    text-align: left
    .title
      color: #f03d37
      font-weight: bold
      font-size: 1.3em
    .subtitle
      color: #f03d37
      font-size: 0.9em
    .text
      color: #333
      font-size: 0.9em
      margin-top: 5px
      padding-bottom: 15px
    .vermas
      background: #f03d37
      border-radius: 50px
      color: #ffffff
      font-weight: 300
      padding: 4px 20px
      font-size: 0.72em
      position: absolute
      bottom: 0
      right: 0
      margin-bottom: -12px
      margin-right: 25px
</style>
